var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 20,
    viewBox: "0 0 6 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.950666 17.1701C0.950666 18.2969 1.87254 19.2188 2.99928 19.2188C4.12601 19.2188 5.04789 18.2969 5.04789 17.1701C5.04789 16.0434 4.12601 15.1215 2.99928 15.1215C1.87254 15.1215 0.950666 16.0434 0.950666 17.1701Z",
    fill: "#F2373E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65865 11.5467L5.34494 3.33177C5.35518 3.27032 5.35518 3.19863 5.35518 3.13718V3.13715C5.35518 1.84653 4.31039 0.78125 2.99928 0.78125C1.61646 0.78125 0.540944 1.9592 0.653618 3.33177L1.3399 11.5467C1.4116 12.4071 2.12862 13.0729 2.99928 13.0729C3.86994 13.0729 4.58695 12.4071 4.65865 11.5467Z",
    fill: "#F2373E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotiRed);
export default __webpack_public_path__ + "static/media/icon_noti_red.6e169c491c76e02ef1b37f49d913f9bf.svg";
export { ForwardRef as ReactComponent };